// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3ESoU","footer":"ModalCreateQualiphyProcedure_footer__1oS8h","additionData":"ModalCreateQualiphyProcedure_additionData__3lVaD"};